module.exports = __webpack_public_path__ + "img/PC080287.7ba21400.jpg";